/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
/* global overlayClick:true */
// 'use strict'

expocadfx.PageControl = function( mgr) {
	var availableTree = expocadfx.availableBoothTree();
    var boothList = expocadfx.boothList();
    var config = expocadfx.config;
    var data = expocadfx.fxData;
	var Dialog = expocadfx.Dialog;
    var elem = expocadfx.element;
    var elemById = elem.elementById;
	var emailLink = expocadfx.emailLinkBuilder;
    var fxStyle = expocadfx.styles;
    var exhibitorInfo = expocadfx.exhibitorInfo;
    var FxEvent = expocadfx.fxevent;
    var HelpWindow = expocadfx.HelpWindow;
    var Legend = expocadfx.Legend;
    var localStorage = expocadfx.localStorage;
    var Login = expocadfx.Login;
	var openEmail = expocadfx.openEmail;
	var pdfOutput = expocadfx.pdfOutput;
    var printList = expocadfx.printList;
    var printExhibitorList = expocadfx.printExhibitors;
    var ProgressBar = expocadfx.ProgressBar;
    var Sales = expocadfx.Sales;
    var SalesMenu = expocadfx.SalesMenu;
    var SalesWindow = expocadfx.SalesWindow;
    var ServerTime = expocadfx.serverTime;
    var txt = expocadfx.txt;
    var util = expocadfx.util;
    
    var dataMgr = mgr;
    var sales = null;
    var salesMenu = null;
    var fp = null;
	var exhInfo = null;
    var winSales = null;
    var winLogin = null;
    var winHelp = null;
	var eliMessageDialog = null;
    
    var doc = document;
    var fpContainer = elemById( "floorplan");
    var iahMsg = null;
    var eliMessage = "";
    
    var currentPage = null;
    var nextPage = null;
    var fpLegend = null;
    var currentButton = null;
    
    var legendOpen = true;
	
	var xmlCategories = null;
	var xmlPavilions = null;
	var xmlSubShows = null;
    var xmlCountries = null;
    
    var jsonCategories = null;
    var jsonPavilions = null;
    var jsonSubShows = null;
    var jsonCountries = null;
    
    var arCategories = [];      //  index from (tree) list items to booths
    var arPavilions = [];
    var arSubShows = [];
    var arCountries = [];
//	var arAvailableBooths = [];
    var currentArray = null;
    var serverTime = null;
    var updateInterval = 0;
    var updateFile = "";
    
    var loginType = "";
    var salesSetupPending = false;
    var btnLogInOut = null;
    var btnSales = null;
    var loginFromExternalCredentials = false;
    var progressBar = null;
    
    var bActivity = false;
    var activityTimer = null;
    var idleMinutes = 0;
    var banner = null;
	
    
    function init() {
        if( config.viewName === "") {
            currentPage = elemById( "views");
        }
        else {
            currentPage = elemById( "floorplan");
        }

        util.addClass( currentPage, "pageactive");
        
        pageSetup( currentPage.id);
        doc.addEventListener( "Floor_Plan_Ready", floorPlanReady);
        doc.addEventListener( "View_Exhibitor_Data_Ready", exhibitorsReady);
        updateInterval = config.updateCheckInterval * 60000;
        updateFile = "u_" + config.viewName + ".xml";
		
        if( config.isXML){
            doc.addEventListener( "Tree_Data_Ready", saveTreeData);
        }
        else{
            doc.addEventListener( "Tree_Data_Ready", saveTreeDataJSON);
        }
        
        
        elemById( "btnUnits").addEventListener( "click", unitsButtonHandler);
        elemById("menu").addEventListener("click", mainMenuClick);
        elemById("control1").addEventListener("click", mainMenuClick);
        elemById( "btnMenu").addEventListener( "click", menuButtonClickHandler);
        elemById( "listWindow").addEventListener( "click", navClickHandler);
       // elemById ("listWindow").addEventListener("mouseout", clearChange);
		
		if( elemById( "menuNavigation")) {
			elemById( "menuNavigation").addEventListener( "click", navClickHandler);
		}
        elemById( "hallGroup").addEventListener( "click", hallClickHandler);
        
        doc.addEventListener( "Booth_Selected", boothSelectionHandler);
        doc.addEventListener( "Floor_Plan_Booth_Click", fpBoothClick);
        doc.addEventListener( "Exhibitor_Selected", showExhibitorInfo);
		
		exhInfo = exhibitorInfo();
    }
    
	function changePage( newPageName) {
		if( newPageName === currentPage.id) {
			return;
		}
		
		startPageTransistion();
	}
	
    function startPageTransistion() {
            // Up and down transition for Accordion
        util.addClass( nextPage, "pageactive");
        if( !( currentPage.getAttribute( "id") === "floorplan" || 
          ( config.viewName === "" && currentPage.getAttribute( "id") === "views"))) {
            currentPage.style.height = "0px";
            setTimeout( clearChange, 200);    //allow time for current page to go toward ht = 0
        }
        else {
            setTimeout( clearChange, 10);  // allow time to add to DOM
        }
        pageSetup( nextPage.id);
    }

    function availHeightSubject(height){
        var num = parseInt(height, 10);
        if(elemById('trA') !== null){
            elemById('trA').style.height = num - 35 + "px"
        }
        return num + "px";
    }

    function clearChange() {
        if( currentPage !== nextPage)  {
            util.removeClass( currentPage, "pageactive");
            if( !(nextPage.getAttribute( "id")  === "floorplan" || 
                  (config.viewName === "" && nextPage.getAttribute( "id") === "views"))) {
                    nextPage.style.height = availHeightSubject(data.pageHeight);
            }
        }
           // document.getElementById("exhibitors").addEventListener("mouseleave", function(){
            //    util.removeClass( currentPage, "pageactive");
           // });
           // document.getElementById("booths").addEventListener("mouseleave", function(){
            //    util.removeClass( currentPage, "pageactive");
           // });
        currentPage = nextPage;
    }
    
    function navClickHandler( evt) {
        if( evt.target.nodeName === "LI" && util.hasClass( evt.target, "nav-btn")) {
            if( currentButton !== null && currentButton.id === evt.target.id) {
                util.removeClass( currentButton, "selected");
				
                currentButton = null;
                if( config.bListPrint) {
                    util.addClass( elemById( "prtList"), "disabled");
                }
				
                if( config.viewName === "") {
					nextPage = elemById( "views");
                    changePage( "views");
                }
                else {
					nextPage = elemById( "floorplan");
					changePage( "floorplan");
                }
            }
            else {
				processPageChange( evt.target);
            }
        }
    }
	
	function processPageChange( target) {
		switch( target.id) {
			case "btnCa":
				nextPage = elemById("categories");
				currentArray = arCategories;
				changePage( "categories");
				break;
			case "btnEx":
				nextPage = elemById( "exhibitors");
				changePage( "exhibitors");
				break;
			case "btnPa":
				nextPage = elemById( "pavilions");
				currentArray = arPavilions;
				changePage( "pavilions");
				break;
			case "btnSs":
				nextPage = elemById( "subshows");
				currentArray = arSubShows;
				changePage( "subshows");
				break;
			case "btnCo":
				nextPage = elemById( "countries");
				currentArray = arCountries;
				changePage( "countries");
				break;
			case "btnAv":
				availableTree.getListElements( data.booths, config.units);
				currentArray = availableTree.getAvailBoothArray();
				elemById( "availBooths").style.left = "0";
				elemById( "availBooths").style.top = "0";
				
				nextPage = elemById( "booths");
				changePage( "booths");
				break;
			case "btnVi":
				nextPage = elemById( "views");
				changePage( "views");
				break;
			case "btnFp":
				nextPage = elemById( "floorplan");
				changePage( "floorplan");
				break;
		}
		if( nextPage !== null) {
			if( currentButton !== null) {
				util.removeClass( currentButton, "selected");
			}
			currentButton = target;
			util.addClass( currentButton, "selected");
			setEvents( currentPage, nextPage);

			if( data.smallLayout || !(!config.showLists && target.id === "btnVi")) {
				util.removeClass( elemById( "btnMenu"), "open");
				util.removeClass( elemById( "menu"), "open");
			}
			if( config.bListPrint) {
				if( currentButton === null || currentButton.id === "btnFp") {
					util.addClass( elemById( "prtList"), "disabled");
				}
				else {
					util.removeClass( elemById( "prtList"), "disabled");
				}
			}
		}
	}
    
    function setEvents( oldPage, newPage) {
        var ul = oldPage.getElementsByClassName( "tree")[0];
        if( ul) {
            // IF( NOT ios) {   ///////////////////
            ul.removeEventListener( "mouseover", mouseOverTreeHandler);
            ul.removeEventListener( "click", clickTreeHandler);
        }
        ul = newPage.getElementsByClassName( "tree")[0];
        if( ul) {
            // IF( NOT ios) {   ///////////////////
            ul.addEventListener( "mouseover", mouseOverTreeHandler);
            ul.addEventListener( "mouseleave", mouseOverTreeHandler);
            ul.addEventListener( "click", clickTreeHandler);
        }
    }
    
    function mouseOverTreeHandler( evt) {
        var index = "";
        
        if( evt.target === "UL") {
            doc.dispatchEvent( new FxEvent( "Unhighlight_Booth", {}));
        }
        else if( evt.target.nodeName === "SPAN") {
            if( util.hasClass( evt.target, "label")) {
                index = currentArray[ evt.target.parentNode.getAttribute( "data-index")];
            }
        }
        else if( evt.target.nodeName === "LI") {
            index = currentArray[ evt.target.getAttribute( "data-index")];
        }
        else {
            doc.dispatchEvent( new FxEvent( "Unhighlight_Booth", {}));
        }
        if( index !== "") {
            doc.dispatchEvent( new FxEvent( "Highlight_Booth", {"index": index}));
        }
    }
    
    function clickTreeHandler( evt) {
        var index = "";
        var flag = false;
		// zoom to booths in 'data-index'
		// mark as selected individual exhibitor's booth(s) or all booths in a catagory
        if( evt.target.nodeName === "SPAN") {
            if( util.hasClass( evt.target, "trigger")) {
                var ul = evt.target.parentElement.getElementsByTagName( "ul")[0];
                if( ul.style.display === "none") {
                    ul.style.display = "block";
                    util.addClass( evt.target, "open");
                }
                else {
                    ul.style.display = "none";
                    util.removeClass( evt.target, "open");
                }
            }
            else {		// span with company name  ||  add category
                index = currentArray[ evt.target.parentNode.getAttribute( "data-index")];
                if( util.hasClass( evt.target.parentNode, "comp") || 
								evt.target.parentElement.parentElement.id === "trCat") {
                    flag = true;
                }
            }
        }
        else {
            index = currentArray[ evt.target.getAttribute( "data-index")];
            if( util.hasClass( evt.target, "comp") || evt.target.parentElement.id === "trCat") {
                flag = true;
            }
        }
        
        if( index && index !== "") {
			if( data.smallLayout && index.length < 20) {
				flag = true;
			}
			
            fp.zoomToBoothIndex( String(index), flag);
            if( data.smallLayout) {
				processPageChange( elemById( "btnFp"));
            }
        }
    }
    
    function boothSelectionHandler( evt) {
        fp.zoomToBoothIndex( evt.data.boothIndex, true);
        if( data.smallLayout) {
			processPageChange( elemById( "btnFp"));
        }
    }
    
    function getLoginScreen( type) {
        if( winLogin === null) {
            winLogin = new Login( type);
        }
        winLogin.initLogin();
        
        doc.addEventListener( "Submit_Login", submitLogin);
        doc.addEventListener( "Cancel_Login", loginCanceled);
        return winLogin.getLoginDiv();
    }
    
    function fx5Login ( type) {
		var storage = localStorage.storageAvailable( "localStorage");
        var div = null;
		var key = "";
		var index = -1;
        loginType = type;
        
        if( type !== "none") {      // 'sales' or 'exhibitor' sales
            sales = new Sales();
            sales.init( dataMgr);
            //      - use same connection on browser refresh.
            doc.addEventListener( "Bearer_Token", bearerTokenResult);

            sales.checkCredentials();
            //sales.checkBearerToken();
        }
        else {      //  handle 'stupid' login
			if( config.password != "" || config.elvis || config.hasMultipleViews) {
			//		check for stored password/token
				
				key = location.pathname;
				index = key.lastIndexOf( "/");
				key = key.substr( 0, index);
				key += "-elip";
                
                if( data.queryCoord !== "" && config.elvis) {
                    // URL intended for responder, no pass, remove ELI functionality
                    data.elvis = false;
                    return;
                }

				if( storage && storage.getItem( key) === config.password) {
					return;
				}
			}
            div = getLoginScreen(type);
            elemById( "appContent").appendChild( div);
        }
        
    }

    function loginRequired( type) {
		var storage = localStorage.storageAvailable( "localStorage");
        var div = null;
		var key = "";
		var index = -1;
        loginType = type;
        
        if( type !== "none") {      // 'sales' or 'exhibitor' sales
            sales = new Sales();
            sales.init( dataMgr);
            sales.setLastMessage( data.lastMessageNumber); // Moved from exhibitorsReady()
            doc.dispatchEvent( new FxEvent( "Sales_Floorplan_Loaded", loadSalesFp(fp)));
            //      - use same connection on browser refresh.
            doc.addEventListener( "Sales_Token", tokenResult);
			
            sales.checkToken();
        }
        else {      //  handle 'stupid' login
			if( config.elvis || config.hasMultipleViews) {
			//		check for stored password/token
				
				key = location.pathname;
				index = key.lastIndexOf( "/");
				key = key.substr( 0, index);
				key += "-elip";
                
                if( data.queryCoord !== "" && config.elvis) {
                    // URL intended for responder, no pass, remove ELI functionality
                    data.elvis = false;
                    return;
                }

				if( storage && storage.getItem( key) === config.password) {
					return;
				}
			}
            div = getLoginScreen(type);
            elemById( "appContent").appendChild( div);
        }
    }
    
    function tokenResult( evt) {
        doc.removeEventListener( "Sales_Token", tokenResult);
        
        if( evt.data.status === "Connected") {
            sales.setLoggedIn( true);
            if( data.status.floorPlanReady && data.status.exhibitorsReady) {
                setUpSales();
            }
            else {
                salesSetupPending = true;
            }
        }
        else {
            doc.addEventListener( "Sales_Token", credentialsResult);
            localStorage.removeSalesInfo();
            sales.checkCredentials();
        }
    }

    function bearerTokenResult( evt){
        doc.removeEventListener( "Bearer_Token", bearerTokenResult);
        
        if( evt.data.status === "Connected" && salesSetupPending == false) {
            sales.setLoggedIn( true);
            if( data.status.floorPlanReady && data.status.exhibitorsReady) {
                setUpSales();
            }
            else {
                salesSetupPending = true;
            }
        }
        else {
            doc.addEventListener( "Bearer_Token", bearerTokenResult);
            //localStorage.removeSalesInfo();
            sales.checkBearerToken();
        }
    }
    
    function credentialsResult( evt) {
        var div;
        doc.removeEventListener( "Sales_Token", credentialsResult);
        
        if( evt.data.status === "Connected") {
            loginFromExternalCredentials = true;
            sales.setLoggedIn( true);
            if( data.status.floorPlanReady && data.status.exhibitorsReady) {
                setUpSales();
            }
            else {
                salesSetupPending = true;
            }
        }
        else {
            div = getLoginScreen(config.salesMode);
            elemById( "appContent").appendChild( div);
        }
    }
    
    function submitLogin( evt) {
		var storage = localStorage.storageAvailable( "localStorage");
		var key = "";
		var index = -1;
		doc.removeEventListener( "Submit_Login", submitLogin);
        if( loginType === "none") {
            if( evt.data.password === dataMgr.zap( config.password)) {
				
				key = location.pathname;
				index = key.lastIndexOf( "/");
				key = key.substr( 0, index);
				key += "-elip";
				
				if( storage) {
					storage.setItem( key, config.password);
				}
                elemById( "appContent").removeChild( winLogin.getLoginDiv());
//                doc.dispatchEvent( new FxEvent( "Login_Complete", {}));
				
            }
            else {
                doc.addEventListener( "Submit_Login", submitLogin);
                winLogin.loginFailed( txt.LOGIN_FAILED);
            }
        }
        else {
            doc.addEventListener( "Open_Result", salesResponseHandler);
            sales.openEvent( evt.data.user, evt.data.password, config.eventName );

             }
    }
    
    function loginCanceled() {
        var dialog = winLogin.getLoginDiv();
		doc.removeEventListener( "Cancel_Login", loginCanceled);
        dialog.parentElement.removeChild( dialog);
        
        config.salesMode = "none";
//        dispatchEvent( new FxEvent( "Login_Complete", {}));
    }
    
    function salesResponseHandler( evt) {
        //   WANT BUTTONS/INTERFACE DISABLED UNTIL SYNC IS COMPLETE  !!!!
        //    mask over entire window to block events? with 10% alpha to see updates occuring ?
        var dialog = winLogin.getLoginDiv();
        doc.removeEventListener( "Open_Result", salesResponseHandler);
		
        if( evt.data.success) {
            dialog.parentElement.removeChild( dialog);
            setUpSales();
        }
        else {
            winLogin.loginFailed( evt.data.message);
            doc.addEventListener( "Submit_Login", submitLogin);
        }
    }
    
    function logInOutHandler() {
        if( sales.getLoggedIn()) {
            disableSales( false);
        }
        else {
            logBackIn();
        }
    }
    
    function disableSales( external) {
        btnSales.style.display = "none";
        if (config.isXML){
            sales.logout( external);
        }
        else{
            // Don't need to logout of events in FX 5? 
            //sales.resetMode( external);
        }
        sales.readyForUpdates = false;
        if( data.salesWindowOpen) {
            winSales.closeWindow();
        }

        btnLogInOut.textContent = txt.SALES_LOGIN;
        sales.setLoggedIn( false);
        clearInterval( activityTimer);
        localStorage.removeSalesInfo();
    }
    
    function logBackIn() {
        var div = getLoginScreen( config.salesMode);
        elemById( "appContent").appendChild( div);
		elemById( "txtId").focus();
    }
    
    function setUpSales() {
        if(config.salesMode === "exhibitor"){
            config.salesUpdateOnly = true;
            
        }
        
        if( config.salesUpdateOnly) {
			window.addEventListener( "beforeunload", function() {
				sales.logout( false);
			});
			
			sales.syncNow( true);
			return;
		}
        doc.addEventListener( "lost_connection_to_edge", lostConnectionToEdge);
        //  initial login vs Re-Login ??
        var toolbar = elemById( "control1");
        if( data.status.floorPlanReady) {
            
            addSalesButton( toolbar);
            if( salesMenu === null && data.salesAllowedCommands.length > 0) {
				//  no => function in IE 11 ( or uglifyjs or my version os eslint)
//				sales.commandLabels = data.salesAllowedCommands.map( num => txt.arSalesCommands[ num]);
				
				sales.commandLabels = data.salesAllowedCommands.map( function(num){
					return txt.arSalesCommands[ num];
				});
				
                // create sales command menu
                salesMenu = new SalesMenu( sales.commandLabels, "legend");

                elemById( "floorplan").appendChild( salesMenu);
                // salesmenu top
                salesMenu.style.top = toolbar.offsetTop + toolbar.offsetHeight + 6 + "px";
                salesMenu.style.display = "none";
            }
            // create sales button and log In/Out button and remove floor plan created date
            elemById( "dftnt").style.display = "none";
            
            progressBar = new ProgressBar();
            elemById( "floorplan").appendChild( progressBar.bar);
            progressBar.text.textContent = "Getting Floor Plan Updates";
            doc.addEventListener( "Sync_Progress", updateProgress);
            progressBar.fill( 0);
            sales.syncNow( true);
            
            doc.addEventListener( "mousedown", activityHandler);
            doc.addEventListener( "touchstart", activityHandler);
            doc.addEventListener( "keydown", activityHandler);
            doc.addEventListener( "User_Activity", activityHandler);
            idleMinutes = 0;
            activityTimer = setInterval( activityTimerHandler, 60000);
        }
        else {
            salesSetupPending = true;
        }
    }
    
    function lostConnectionToEdge() {
        console.log( "Lost Connection Event - Disabled!");
        //  same as log out
        disableSales( false);
    }
    
    function updateProgress( evt) {
        var pct = evt.data.prog;
        if( pct < 1) {
            progressBar.fill( pct);
        }
        else {
            doc.removeEventListener( "Sync_Progress", updateProgress);
            progressBar.fill( 0);
            elemById( "floorplan").removeChild( progressBar.bar);
        }
    }
    
    function addSalesButton( toolbar) {
        var bgColor = fxStyle.fpToolbar.clrBg !== "" ?
            fxStyle.fpToolbar.clrBg : fxStyle.floorplan.clrBg !== "" ?
            fxStyle.floorplan.clrBg : fxStyle.mainHeader.clrBg;

        var txtColor = fxStyle.fpToolbar.clrText !== "" ?
            fxStyle.fpToolbar.clrText : fxStyle.floorplan.clrText !== "" ?
            fxStyle.floorplan.clrText : fxStyle.mainHeader.clrText;
        
        if( btnLogInOut === null) {
            btnLogInOut = elem.makeIconButton( "", txt.SALES_LOGOUT, bgColor, txtColor,
												null, true, fxStyle.fpToolbar.alpha);
            btnLogInOut.className = "hdr-btn waves-effect waves-light";
            
            toolbar.appendChild( btnLogInOut, elemById( "tb2"));
            
            btnLogInOut.addEventListener( "click", logInOutHandler);
        }
        btnLogInOut.textContent = txt.SALES_LOGOUT;
        if( loginFromExternalCredentials || !config.isXML) {
            btnLogInOut.style.display = "none";
        }
        
        if( btnSales === null) {
            btnSales = elem.makeIconButton( "", txt.SALES_LABEL, bgColor, txtColor,
											null, true, fxStyle.fpToolbar.alpha);
            btnSales.className = "hdr-btn waves-effect waves-light";
            
            toolbar.appendChild( btnSales, btnLogInOut);
            
            if( data.salesAllowedCommands.length > 0) {
                btnSales.addEventListener( "click", salesButtonHandler);
            }
        }
        else {
            btnSales.style.display = "inline-block";
        }
    }
    
    function activityHandler() {
        bActivity = true;
    }
    
    function activityTimerHandler() {
        if( bActivity) {
            idleMinutes = 0;
            bActivity = false;
        }
        else {
            idleMinutes += 1;
            if( (idleMinutes > data.salesIdleLimit) && config.isXML) {
                disableSales( false);
                clearInterval( activityTimer);
            }
        }
    }
    
    function salesButtonHandler( evt) {
        evt.stopImmediatePropagation();
        if( data.salesWindowOpen) {
            return;
        }
        
        if( salesMenu.style.display === "block") {
            salesMenu.style.display = "none";
            salesMenu.removeEventListener( "click", salesMenuClick);
            elemById( "appContent").removeEventListener( "click", closeSalesMenu);
        }
        else {
            salesMenu.style.display = "block";
            salesMenu.style.right = (elemById("control1").clientWidth + 111 - salesMenu.clientWidth) + "px";
            salesMenu.style.opacity = "1";
            salesMenu.addEventListener( "click", salesMenuClick);
            elemById( "appContent").addEventListener( "click", closeSalesMenu);
        }
    }
    
    function salesMenuClick( evt) {
		evt.stopImmediatePropagation();
		evt.stopPropagation();
		
        if( evt.target.tagName === "LI") {
            salesMenu.style.display = "none";   // ? move to 'SalesMenu'
            if( winSales === null) {
                winSales = new SalesWindow( config.salesMode, sales);
            }
            winSales.openWindow( evt.target.textContent);
            doc.addEventListener( "Booth_Click", salesBoothClickHandler);
            doc.addEventListener( "Sales_Window_Closed", salesWindowClosed);
        }
    }
    
    function closeSalesMenu( evt) {
        evt.stopImmediatePropagation();
        
        salesMenu.style.display = "none";
        salesMenu.removeEventListener( "click", salesMenuClick);
        elemById( "appContent").removeEventListener( "click", closeSalesMenu);
    }
    
    function salesBoothClickHandler( evt) {
        //  evt.data is the booth
        if(config.isXML){
            var result = null;
            if( winSales && data.salesWindowOpen) {
                result = winSales.setBoothNumber( evt.data);
    
                if( result.unselect !== "") {   //  returns booth number(s)
                    fp.unOutlineBooth( result.unselect);
                }
                if( result.select !== "") {
                    fp.outlineBooth( data.boothGraphics[ evt.data.index]);
                }
            }
        }
        else{

            doc.addEventListener( "Result_Booth_Lock_Status", salesBoothLockHandler);

            evt.data.isBooth = true; // Allows evt object to be passed as a param which the locked result msg gets added to
            sales.getBoothLockStatus(evt.data);
        }
        

    }

    function salesBoothLockHandler ( evt) {
        var boothLock = evt.data.locked; // Check for booth lock [EdgeApi/{databaseName}/fx/boothlocked]

            if(boothLock.viewRestricted || boothLock.siSRestricted || boothLock.pavilionRestricted ){
                window.parent.swal("", boothLock.message, "warning");

                return;
            }

            if (boothLock.lockStatus !== '0'){ 
                
                if (boothLock.lockStatus === '10'){
                    window.parent.swal("", "Booth is currently being purchased by an exhibitor.", "warning");
                }
                else if (Number(boothLock.Code) < 0) {
                    window.parent.swal("", "Something went wrong. Please contact show management or try selecting another booth.", "warning");
                }
                else {
                    window.parent.swal("", "Booth is currently being modified by a Show Managment user.", "warning");
                }
                
            }
            else if (boothLock.lockStatus === '0'){
                var result = null;
                if( winSales && data.salesWindowOpen) {
                    result = winSales.setBoothNumber( evt.data);
        
                    if( result.unselect !== "") {   //  returns booth number(s)
                        fp.unOutlineBooth( result.unselect);
                    }
                    if( result.select !== "") {
                        fp.outlineBooth( data.boothGraphics[ evt.data.index]);
                    }
                }
            }       
    }
    
    function salesWindowClosed() {
        fp.unOutlineBooth( null);
    }
    
    function handleAdBanner( adBanner) {
        banner = adBanner;
        doc.addEventListener( "Ad_Click", adClickHandler);
    }
    
    function adClickHandler( evt) {
        var boothIndex = null;
        var indices = [];
        var arBoothNumbers;
        var i;
        
        if(!config.bUseApi || String(overlayClick(evt.data.imgSource,evt.data.url,evt.data.name) === "1")) {  
            if( evt.data.boothNumber !== "") {
                arBoothNumbers = String( evt.data.boothNumber).split(",");
                
                for( i = 0; i < arBoothNumbers.length; i++) {
                    boothIndex = util.findBoothIndex( arBoothNumbers[i], data.booths);
                    if( boothIndex !== null && boothIndex !== -1) {
                        indices.push( boothIndex);
                    }
                    
                    boothIndex = indices.join( ",");
                    fp.zoomToBoothIndex( String(boothIndex), true);
                    if( data.smallLayout) {
						processPageChange( elemById( "btnFp"));
                    }
                }
            }
            //  if navTo && zoomTo, zoom first and delay navigation to see the zoom
            if( evt.data.url !== "") {
                if( evt.data.boothNumber === "") {
                    util.navigateTo( evt.data.url);
                }
                else {
                    window.setTimeout( util.navigateTo, 700, evt.data.url);
                }
            }
        }
    }
    
    function initPeriodicFunctions() {
        if( config.updateCheckInterval > 0 && config.salesMode === "none") {
            setTimeout( getUpdateFile, updateInterval);
        }
        if( config.bServerTime) {
            //if(config.isXML == true){ //Only need this XML version? 
                serverTime = new ServerTime();
                var timeDisplay = serverTime.getServerTimeHtml();
                elemById( "floorplan").appendChild( timeDisplay);
                
                setInterval( updateTimeFromServer, 180000);
                updateTimeFromServer();
            //}

        }
    }
    
    function getUpdateFile() {
        if( typeof( dataMgr.loadData) !== "function") {
            console.log( "Data Loader Not Available");
        }
        else {
            dataMgr.loadData( updateFile, "important", checkForUpdates);
        }
    }
    
    function checkForUpdates( success, results) {
        var xml;
        var updateNumber = 0;
        if( success) {
            xml = results.getElementsByTagName("U")[0];
            if( xml) {
                updateNumber = parseInt(xml.getAttribute("u"), 10);
                if( updateNumber > data.updateNumber) {
                    data.updateNumber = updateNumber;
                    refreshMessage();
                }
                else {
                    setTimeout( getUpdateFile, updateInterval);
                }
            }
        }
    }
    
    function refreshMessage() {
        var divMessage = doc.createElement( "div");
        var txtMessage = doc.createElement( "p");
        var fromTop = elemById( "control1").offsetTop + 20 + "px";
        var fromLeft = (elemById( "floorplan").clientWidth * 0.5) - 150 + "px";
        divMessage.className = "dialog refresh_message";
        txtMessage.className = "refresh_message_text";
        
        txtMessage.textContent = txt.REFRESH_MESSAGE;
        divMessage.appendChild( txtMessage);
        
        elemById( "floorplan").appendChild( divMessage);
        divMessage.style.top = fromTop;
        divMessage.style.left = fromLeft;
        divMessage.style.display = "block";
    }
    function updateTimeFromServer() {
        if (config.isXML){
            if( typeof( dataMgr.loadData) !== "function") {
                console.log( "Data Loader Not Available");
            }
            dataMgr.loader.requestWithScript( "servertime", serverTime.updateTimeFromServer);
        }
        else {
            serverTime.updateTimeFromServer(true, config.serverTimeXML);
        }
    }
    
    function fpBoothClick( evt) {

        if( config.salesMode === "sales" && sales.getLoggedIn() &&
            config.holdMode && evt.data.status === "1" && config.holdModeExhibitorName) {
            //  get actual exhibitor name from EDGE
            doc.addEventListener( "Exhibitor_Name_Result", holdNameHandler);
            sales.getExhibitorName( evt.data.number);
        }
        
        if( config.salesMode === "exhibitor" && sales.getLoggedIn() && (evt.data.status === "0" || evt.data.status === "1")){
            //doc.addEventListener( "Result_Booth_Lock_Status", sales.getBoothLockStatus(evt.data.number));
            evt.data.isBooth = true;
            sales.getBoothLockStatus(evt.data)

            return;
        }
        // TODO MAKE SURE TO UNCOMMENT
        exhInfo.populateFromFloorPlan(evt.data);
        // TODO MAKE SURE TO ADD UNCOMMENT
        // if (data.rentMode) {
        //     // bring up flyout with exhibitors dropdown so user can select who to rent booth to
        //     modal = document.getElementById('myModal');
        //     modal.style.display = "block";
        //     modalContent = document.getElementById('modalContent');
        //     util.ajaxCall("http://localhost:52953/api/show_event/GetExhibitors/2", "GET", null, populate);
        // }
    }
    
    function holdNameHandler( evt) {
		doc.removeEventListener( "Exhibitor_Name_Result", holdNameHandler);
        if( evt.data.ExhibitorName !== "") {
            exhInfo.changeExhibitorName( evt.data.ExhibitorName);
        }
    }
    
    function showExhibitorInfo( evt) {
        if(config.exhibitorDirectory && data.exhibitors[evt.data.exhibitorIndex].exhId !== ""){
            fp.createModal();
            fp.switchDirectoryDialog(data.exhibitors[evt.data.exhibitorIndex].exhId);
        }
        else{
            exhInfo.populateFromExhibitorList( evt.data.exhibitorIndex, evt.data.boothIndex, true);
        }
        
    }
    
    function hallClickHandler( evt) {
        var element = evt.target;
        var index = 0;
        var url = location.origin + location.pathname;
        if( element.tagName === "IMG" || element.tagName === "P") {
            element = element.parentNode;
        }
        
        if( util.hasClass( element, "thumb")) {
            index = element.getAttribute( "data-index");
            if( data.arViews[index].name !== config.viewName) {
                
                if(config.isXML){
                    url += "?event=" + data.arViews[index].name;
                }
                else if (config.viewAll){
                    url += "?view=" + data.arViews[index].name;
                }

                if( config.salesMode != "none"){
                    url += "&mode=" + config.salesMode;
                }
                
                window.location = url;
            }
        }
    }
    function mainMenuClick( evt) {
        var hdr = null;
        var content;
        var item = evt.target;
        var url = "";
        var fileName = "";
        var index = 0;
        var itemId = "";
        var ThreeDEl = document.querySelector('#show3d');
        
        if( item.tagName === "LI" || item.tagName === "BUTTON" || item.tagName === "SPAN") {
			itemId = evt.target.id;  // item.getAttribute( "id");
			
			switch( itemId) {
                case "copyBooth":
                util.toggleClass( item, "icon-check");

                if(data.copyBooth){
                    data.copyBooth = false;    
                        //clear booth from data and scene   
                }
                else{
                    data.copyBooth = true;
                }
                console.log("copy booth mode" + data.copyBooth);

				case "map":
					if( util.toggleClass( item, "icon-check")) {
						elemById( "minimap").style.display = "block";
                    }
					else {
						elemById( "minimap").style.display = "none";
					}
                    break;        
                case "show3dLabel":
					 if(util.toggleClass( item, "icon-check")) {
						fp.show3d();
                        disableLayerItems();
                        ThreeDEl.style.color= fxStyle.view.clrBg !== "" ? fxStyle.view.clrBg : fxStyle.mainHeader.clrBg;
                        ThreeDEl.style.background = "none";
                    }  
					else {
                        ThreeDEl.style.background = 'none';
                        ThreeDEl.style.color = 'white';
						fp.show2d();
                        enableLayerItems();
					}
                    break;
                case "show3d":
					if(util.toggleClass( item, "icon-check")) {
						fp.show3d();
                        disableLayerItems();
                        if(!data.smallLayout && !config.bToolbar === "false"){
                            ThreeDEl.style.color= fxStyle.view.clrBg !== "" ? fxStyle.view.clrBg : fxStyle.mainHeader.clrBg;
                            ThreeDEl.style.background = "none";
                        }
                    }  
					else {
                        if(!data.smallLayout && !config.bToolbar === "false"){
                            ThreeDEl.style.background = 'none';
                            ThreeDEl.style.color = 'white';
                        }
						fp.show2d();
                        enableLayerItems();
					}
					break;
				case "pdf":
					fileName = data.arViews.length > 1 ? config.viewName + ".pdf" : "floorplan.pdf";
					index = location.href.lastIndexOf( "/");

					url = location.href.substr( 0, index + 1) + fileName;
					window.open( url);
					break;
				case "prtFp":
					printFloorPlan( true);
					break;
				case "prtWin":
					printFloorPlan( false);
					break;
				case "build":
					data.bDrawBuilding = util.toggleClass( item, "icon-check");	
					fp.redraw();
					break;
				case "bthDimensions":
					if( !util.hasClass( elemById( "bthDimensions"), "disabled")) {
                        config.showDimensions = util.toggleClass( elemById( "bthDimensions"), "icon-check");
						fp.redraw();
					}
					break;
				case "help":
					openHelp();
					break;
				case "iah":
					if( config.elvis) {
						showEliMessages();
					}
					else {
						enableIAmHereClick();
					}
					break;
                case "wayfind":
                    wayfinder();
                    break;
				case "prtList":
					if( currentButton !== null) {
						hdr = expocadfx.printHeader( config.eventTitle, config.viewTitle,
													config.hasMultipleViews);
						if( currentButton.id === "btnVi") {
							content = expocadfx.printHalls( data.arViews);
						}
						else if( currentButton.id === "btnEx") {
							content = printExhibitorList( data.displayExhibitors,
														elemById( "exhibitorFilter").value,
														config.viewName,
														txt.EXHIBITOR,
														txt.BOOTH);
						}
						else if( currentButton.id === "btnAv") {
							content = printExhibitorList( data.displayBooths,
														elemById( "boothFilter").value,
														config.viewName,
														txt.EXHIBITOR,
														txt.BOOTH);
						}
						else {      // list is a tree
							content = expocadfx.printTree( currentButton, currentArray, data.booths);
						}
						printList( hdr, content);
					}
					break;
				default:
					if( itemId.indexOf( "layer") === 0 && !util.hasClass( item, "disabled")) {
						if( util.toggleClass( item, "icon-check")) {
							data.arTechLayers[ parseInt( itemId.substr( 6), 10)].visible = true;
						}
						else {
							data.arTechLayers[ parseInt( itemId.substr( 6), 10)].visible = false;
						}
						fp.redraw();
					}
			}
			if( config.showLists || evt.target.id !== "btnVi") {
                closeMainMenu();
            }
            doc.addEventListener( "Floor_Plan_Tap", floorPlanClick);
            return true;
        }
    }
	
	function enableLayerItems() {
		data.arLayersMenuItems.forEach( function( item) {
            util.removeClass( item, "disabled");
		});
        util.removeClass( elemById( "bthDimensions"), "disabled");
	}

	function disableLayerItems() {
		data.arLayersMenuItems.forEach( function( item) {
			util.addClass( item, "disabled");
		});
		util.addClass( elemById( "bthDimensions"), "disabled");
		
	}
    
    function closeMainMenu( evt) {
        if( evt) {
            evt.stopImmediatePropagation();
        }
        
		util.removeClass( elemById( "btnMenu"), "open");
		util.removeClass( elemById( "menu"), "open");
		elemById( "appContent").removeEventListener( "click", closeMainMenu);
		data.menuPending = false;
    }
    
    function showEliMessages() {
        var obj = null;
        var i = 0;
        var list = null;
        var item = null;
        
        if( eliMessageDialog === null) {
            obj = {
                title: "Emergency Messages",
                headerBackgroudColor: fxStyle.windowHeader.clrBg !== "" ? 
                    fxStyle.windowHeader.clrBg : fxStyle.mainHeader.clrBg,
                headerBackground: (fxStyle.windowHeader.gradBg !== "") ? 
                    fxStyle.windowHeader.gradBg : (fxStyle.windowHeader.clrBg === "") ?
                        fxStyle.mainHeader.gradBg : "",
                headerTextColor: fxStyle.windowHeader.clrText !== "" ? 
                    fxStyle.windowHeader.clrText : fxStyle.mainHeader.clrText,
                cancelLabel: txt.CANCEL,
                width: 300,
                height: 400,
                posX: data.viewportWidth / 2 - 150,
                posY: data.viewportHeight / 2 - 200,
                draggable: true
            };
            
            eliMessageDialog = new Dialog( obj, elemById( "floorplan"), elemById( "mask"));
            list = doc.createElement( "ul");
            list.setAttribute('id', 'elvisList');
            for( i = 0; i < config.elvisMessages.length; i++) {
                item = doc.createElement( "li");
                item.className = "salesItem";
                item.textContent = config.elvisMessages[i].msg;
                list.appendChild( item);
            }
            
            eliMessageDialog.content.appendChild( list);
            list.addEventListener( "click", closeEliDialog);
        }
        elemById( "appContent").appendChild( eliMessageDialog.window);
        
        eliMessageDialog.open();
    }
    
    function closeEliDialog( evt) {
        eliMessage = evt.target.textContent;
        eliMessageDialog.close();
        if( config.locationAvailable && config.locationEnabled && config.lastXY) {
        //if( config.locationAvailable && config.locationEnabled && config.lastXY && confirm("Send your location?")) {
            swal({
                title: "Send Your Location?",
                text: "",
                icon: "warning",
                buttons: ["Select a Different Location", "Send"],
                dangerMode: false,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        obj = { pageX: config.lastXY[0], pageY: config.lastXY[1]};
                        processIamhereClick( obj, true);                    
                    } else {
                        setTimeout( enableIAmHereClick, 400);
                    }
                }) 

        }
        else{
            setTimeout( enableIAmHereClick, 400);
        }
        
    }
    
    function enableIAmHereClick() {
		elemById("floorplan").style.cursor = "url(./del_32.png), crosshair";
		data.iahPending = true;
        fpContainer.addEventListener( "click", iamhereClick);
        fpContainer.addEventListener( "tap", iamhereClick);
        doc.addEventListener( "Floor_Plan_Tap", floorPlanClick);
        iahPrompt();
    }

    function wayfinder() {
        data.activeWayPath.length = 0;
        data.wayPending = true;
        wayOriginPrompt();
    }
    
    function iahPrompt() {
        iahMsg = document.createElement( "div");
        iahMsg.setAttribute( "id", "iahMsg");
        iahMsg.textContent = "Click to send a location";
        fpContainer.appendChild( iahMsg);
    }

    function wayOriginPrompt() {
        iahMsg = document.createElement( "div");
        iahMsg.setAttribute( "id", "iahMsg");
        iahMsg.textContent = "Select Origin Booth";
        fpContainer.appendChild( iahMsg);
        doc.addEventListener("Booth_Click", setWayOrigin);
    }

    function setWayOrigin(evt){
        doc.removeEventListener("Booth_Click", setWayOrigin, true);
        data.wayOriginObj = evt.data;
        // evt.stopImmediatePropagation();
        // evt.stopPropagation();
        setWayDestination();
        
    }
    
    function setWayDestination() {
        fpContainer.removeChild( iahMsg);
        iahMsg = document.createElement( "div");
        iahMsg.setAttribute( "id", "iahMsg");
        iahMsg.textContent = "Select Destination Booth";
        fpContainer.appendChild( iahMsg);
        doc.addEventListener("Booth_Click", wayFindClick, true);
    }
    
    function printFloorPlan( full) {
		var script = "";
		var style = "";
		var win = null;
		var fpImg = null;
		var w = data.viewportHeight * 1.55 + "px";      // maintain aspect ratio
		var h = data.viewportHeight + "px";
		var docType = "<!DOCTYPE html";
		
		if( full && data.pdfOk && fp.is2d()) {
            pdfOutput( printFloorPlan);
		}
		else {
			win = window.open();
			fpImg = fp.getFloorPlanImage( full);

			style = "<style>@media screen{body{width:"+w+";height:"+h+";margin:0;}}";
			style += "@media print{body{width:11in;height:7.1in;}img{max-width:11in;max-height:7in;}";
			style += "</style>";
				//  need delay for Chrome to finish loading image
			script = "<script>function prt(){setTimeout(function(){window.print();window.close()},10);}</script>";

			win.document.write( docType);
			win.document.write('<html><head><title>Print Floor Plan</title>');
			win.document.write( style);
			win.document.write( script);
			win.document.write('</head><body onload="prt()">');
			win.document.write( "<img src='"+ fpImg +"'/>");
			win.document.write('</body></html>');

			win.document.close();

			win.document = null;
			win = null;
		}
    }
	
    function iamhereClick( evt) {
        var obj;
        evt.stopImmediatePropagation();
        evt.stopPropagation();
        
        obj = { pageX: evt.pageX, pageY: evt.pageY};
        processIamhereClick( obj);
    }

    function wayFindClick( evt){
        doc.removeEventListener("Booth_Click", wayFindClick, true);
        data.wayPending = false;
        var destinationObj;
        evt.stopImmediatePropagation();
        evt.stopPropagation();
        
        destinationObj = evt.data;
        processWayFindClick( data.wayOriginObj, destinationObj);
    }
    
    function floorPlanClick( evt) {
        if( data.iahPending) {
            processIamhereClick( evt.data);
        }
        else {
            closeMainMenu();
        }
    }

    function processWayFindClick( originObj, destinationObj){

        var origin = originObj.number;
        var destination = destinationObj.number;
        data.wayPathDestinationGraphic = destinationObj;
        var path = [];

        if (true){
            var startx = originObj.graphic.text[0].x;
            var starty = originObj.graphic.text[0].y;
            var goalx = destinationObj.graphic.text[0].x;
            var goaly = destinationObj.graphic.text[0].y;

            var startXBoard = -1;
            var startYBoard = -1;
            var goalXBoard = -1; 
            var goalYBoard = -1;

            var distStart = -1;
            var distGoal = -1;
            var distance = -1;

            for(i = 0; i < data.boardNumXPoints; i++){
               

                for (j = 0; j < data.boardNumYPoints; j++){

                    if(data.board[i + j * data.boardNumXPoints] === 0){
                        
                        var firstSquared = Math.pow(startx - data.boardXValues[i],2);
                        var secondSquared = Math.pow(starty - data.boardYValues[j],2);

                        distance = Math.sqrt( firstSquared + secondSquared );

                        if(distStart === -1 || distance < distStart){
                            startXBoard = i;
                            startYBoard = j;

                            distStart = distance;
                        }
                    }
                }              
            }

            //distance = -1;

            for(i = 0; i < data.boardNumXPoints; i++){
               

                for (j = 0; j < data.boardNumYPoints; j++){

                    if(data.board[i + j * data.boardNumXPoints] === 0){

                        var firstSquared = Math.pow(goalx - data.boardXValues[i],2);
                        var secondSquared = Math.pow(goaly - data.boardYValues[j],2);

                        distance = Math.sqrt( firstSquared + secondSquared );

                        if(distGoal === -1 || distance < distGoal){
                            goalXBoard = i;
                            goalYBoard = j;

                            distGoal = distance;
                        }
                    }

                }
            }

            var output = aStar(data.board, startXBoard, startYBoard, goalXBoard, goalYBoard);

            for (i = 0; i < output.length; i++){
                
                var x = output[i][0];
                var y = output[i][1];

                data.activeWayPath.push([data.boardXValues[x], data.boardYValues[y]]);
            }

            doc.dispatchEvent( new FxEvent( "Draw_Waypath", null));
            fpContainer.removeChild( iahMsg);
        }
    }

    function manhattan(x1, y1, x2, y2) {
        return Math.abs(x1 - x2) + Math.abs(y1 - y2);
    }

    function aStar (board, startx, starty, goalx, goaly,
        open = Array(data.boardNumXPoints * data.boardNumYPoints).fill(null),
        closed = Array(data.boardNumXPoints * data.boardNumYPoints).fill(null),
        current = {
            "coord": [startx, starty],
            "distance": 0,
            "heuristic": manhattan(startx, starty, goalx, goaly),
            "previous": null
        }) {
        const [x, y] = [...current.coord];
     
        if (x === goalx && y === goaly) {
            closed[x + y * data.boardNumXPoints] = current;
            return (lambda = (closed, x, y, startx, starty) => {
                if (x === startx && y === starty) {
                    return [[x, y]];
                }
                const [px, py] = closed.filter(e => e !== null)
                    .find(({coord: [nx, ny]}) => {
                        return  nx === x && ny === y
                    }).previous;
                return lambda(closed, px, py, startx, starty).concat([[x,y]]);
            })(closed, x, y, startx, starty);
        }
     
        let newOpen = open.slice();
        [
            [x + 1, y + 1], [x - 1, y - 1], [x + 1, y], [x, y + 1],
            [x - 1, y + 1], [x + 1, y - 1], [x - 1, y], [x, y - 1]
        ].filter(([x,y]) => x >= 0 && x < data.boardNumXPoints &&
                            y >= 0 && y < data.boardNumYPoints &&
                            closed[x + y * data.boardNumXPoints] === null
        ).forEach(([x,y]) => {
            newOpen[x + y * data.boardNumXPoints] = {
                "coord": [x,y],
                "distance": current.distance + (board[x + y * data.boardNumXPoints] === 1 ? 100 : 1),
                "heuristic": manhattan(x, y, goalx, goaly),
                "previous": [...current.coord]
            };
        });
     
        let newClosed = closed.slice();
        newClosed[x + y * data.boardNumXPoints] = current;
     
        const [newCurrent,] = newOpen.filter(e => e !== null)
            .sort((a, b) => {
                return (a.distance + a.heuristic) - (b.distance + b.heuristic);
            });
     
        const [newx, newy] = [...newCurrent.coord];
        newOpen[newx + newy * data.boardNumXPoints] = null;
     
        return aStar(board, startx, starty, goalx, goaly,
            newOpen, newClosed, newCurrent);
    }
	
    function processIamhereClick( obj, locationUsed) {
        var link = "";
        var fpPt = null;
        var content = "";
        var nums = "";
        var ref = "";
		var msgObj;
        
        fpContainer.removeEventListener( "click", iamhereClick);
        fpContainer.removeEventListener( "tap", iamhereClick);
        doc.removeEventListener( "Floor_Plan_Tap", floorPlanClick);
        
        elemById( "floorplan").style.cursor = "auto";
		
        if(locationUsed){
            fpPt = { x:obj.pageX, y:obj.pageY};
        }
        else{
            
            fpContainer.removeChild( iahMsg);

            if( data.msie) {
                //obj.pageY -= 32;
            }
            //  need to convert coords to drawing context

            //Not sure what the 16x16 and 32 were for but was messing with accuracy
            //fpPt = fp.globalToFloorPlan( { x:obj.pageX + 16, y:obj.pageY + 16});
            fpPt = fp.globalToFloorPlan( { x:obj.pageX, y:obj.pageY});
        }
        
        if( fpPt === null) {
            return;
        }
		
        link = emailLink( fpPt);
		
        if( config.elvis) {
            link += "," + eliMessage;
        }
		
		if( config.elvis && data.device !== "other") {
			content = encodeURIComponent( link);
			msgObj = util.arrayFind( config.elvisMessages, "msg", eliMessage);
			nums = config.elvisNumbers[ msgObj.numGroup];
			
			if( data.device === "ios") {
				ref = "sms://open?addresses=" + nums + "&" + "body=" + content;
			}
			else {
				nums = nums.split( ",").join( ";");
				ref = "sms:" + nums + "?" + "body=" + content;
			}

			window.location.href = ref;
		}
		else {
			openEmail( link);
		}
    }
    
    function openHelp() {
        if( winHelp === null) {
            winHelp = new HelpWindow( txt, fxStyle);
        }
        winHelp.window.style.display = "block";
    }
    
    function menuButtonClickHandler() {
        if( util.toggleClass( elemById( "btnMenu"), "open")) {
            elemById( "appContent").addEventListener( "click", closeMainMenu);
            data.menuPending = true;
        }
        util.toggleClass( elemById( "menu"), "open");
    }
    
    function pageSetup( pageId) {
        if( pageId === "exhibitors") {
            if( data.grid === null) {
                dataMgr.checkForExhibitors();
            }
        }
    }
    
    function unitsButtonHandler( evt) {
        if( util.hasClass( evt.currentTarget, "on")) {
            util.removeClass( evt.currentTarget, "on");
            config.units = "F";
        } else {
            util.addClass( evt.currentTarget, "on");
            config.units = "M";
        }
        //  for booth list
        dataMgr.changeExhibitorNameField( config.units);
		
        boothList.refreshList();
		
		availableTree.toggleAvailableLabels(config.units);
		
        updateListUnits();
    }
    
    function floorPlanReady() {
        document.removeEventListener( "Floor_Plan_Ready", floorPlanReady);
        data.status.floorPlanReady = true;
		
        if( config.isXML){
            dataMgr.parseExhibitorData();
            processTreeData();
        }
        else{
            dataMgr.parseExhibitorSQL();
            processTreeDataJSON();
        }

		initLegend();
    }
    
    function exhibitorsReady() {
        document.removeEventListener( "View_Exhibitor_Data_Ready", exhibitorsReady);
        data.status.exhibitorsReady = true;
        
        dataMgr.updateDisplayObjects();
        
        if( sales !== null) {
            // Following has timing issue with slow connections, actions endpoint called before lastMessageNumber set -AH 5/7/2019
            //sales.setLastMessage( data.lastMessageNumber);
            doc.dispatchEvent( new FxEvent( "Sales_Floorplan_Loaded", loadSalesFp(fp)));
            

            if( salesSetupPending) {
                setUpSales();
            }
        }
    }
    
    function addPage( btnId, divId1, divId2) {
        var newDiv = elem.newTreePage( divId1, divId2);
        newDiv.style.height = "0px";        // will expand on tab click ( if tab)
        
        if( data.smallLayout) {
            elemById( "appContent").appendChild( newDiv);
        }
        else {
            elemById( btnId).appendChild( newDiv);
        }
    }

    function saveTreeDataJSON(evt) {
        if( evt.data.type === "cat") {
            jsonCategories = evt.data.jsonObject; 
        }
        else if( evt.data.type === "pav") {
            jsonPavilions = evt.data.jsonObject;
        }
        else if( evt.data.type === "sis") {
            jsonSubShows = evt.data.jsonObject;
        }
        else if( evt.data.type === "country") {
            jsonCountries = evt.data.jsonObject;
        }
	}

	function saveTreeData(evt) {
        if( evt.data.type === "cat") {
            xmlCategories = evt.data.xml;
        }
        else if( evt.data.type === "pav") {
            xmlPavilions = evt.data.xml;
        }
        else if( evt.data.type === "sis") {
            xmlSubShows = evt.data.xml;
        }
        else if( evt.data.type === "country") {
            xmlCountries = evt.data.xml;
        }
	}
    
	
	function getTreeBackgroundColor( treeStyle) {
		return  treeStyle.clrBg || fxStyle.mainHeader.clrBg;
    }
    
 function processTreeDataJSON() {
    var html = null;
    var bgClr = "#0000ff";
    
    var decrp = config.bDataEncrypted ? dataMgr.zap : null;
    if( jsonCategories) {
        addPage( "btnCa", "categories", "trcCat");
        
        bgClr = getTreeBackgroundColor( fxStyle.category);
        
        html = elem.jsonToTree( jsonCategories, "trCat", arCategories, decrp, bgClr);
        elemById( "trcCat").appendChild( html);
      //  document.getElementById("categories").addEventListener("mouseleave", function(){
        //    util.removeClass( currentPage, "pageactive");
      //  });
        jsonCategories = null;
    }
    if( config.bCountryData == true && !config.bHideCountryList) {
        addPage( "btnCo", "countries", "trcCn");
        bgClr = getTreeBackgroundColor( fxStyle.country);
        
        html = elem.jsonToTree( jsonCountries, "trCn", arCountries, decrp, bgClr);
        elemById( "trcCn").appendChild( html);
       // document.getElementById("countries").addEventListener("mouseleave", function(){
        //    util.removeClass( currentPage, "pageactive");
       // });
        jsonCountries = null;
    }
    if( config.bSubShowData == true) {
        addPage( "btnSs", "subshows", "trcSis");
        bgClr = getTreeBackgroundColor( fxStyle.subShow);
        
        html = elem.jsonToTree( jsonSubShows, "trSis", arSubShows, decrp, bgClr);
        elemById( "trcSis").appendChild( html);
        toggleTreeUnits( "trSis", config.units, arSubShows);
       // document.getElementById("subshows").addEventListener("mouseleave", function(){
        //    util.removeClass( currentPage, "pageactive");
       // });
        jsonSubShows = null;
    }
    if( config.bPavilionData == true) {
        addPage( "btnPa", "pavilions", "trcP");
        bgClr = getTreeBackgroundColor( fxStyle.pavilion);
        
        html = elem.jsonToTree( jsonPavilions, "trP", arPavilions, decrp, bgClr);
        elemById( "trcP").appendChild( html);
        toggleTreeUnits( "trP", config.units, arPavilions);
      //  document.getElementById("pavilions").addEventListener("mouseleave", function(){
      //      util.removeClass( currentPage, "pageactive");
      //  });
        jsonPavilions = null;
    }
}

    // Put JSON list objects into trees? 
    function processTreeData() {
        var html = null;
        var bgClr = "#0000ff";
        
        var decrp = config.bDataEncrypted ? dataMgr.zap : null;
        if( xmlCategories) {
            addPage( "btnCa", "categories", "trcCat");
			bgClr = getTreeBackgroundColor( fxStyle.category);
			
            html = elem.xmlToTree( xmlCategories, "trCat", arCategories, decrp, bgClr);
            elemById( "trcCat").appendChild( html);
        //    document.getElementById("categories").addEventListener("mouseleave", function(){
        //        util.removeClass( currentPage, "pageactive");
        //    });
			xmlCategories = null;
        }
        if( xmlCountries) {
            addPage( "btnCo", "countries", "trcCn");
            bgClr = getTreeBackgroundColor( fxStyle.country);
			
            html = elem.xmlToTree( xmlCountries, "trCn", arCountries, decrp, bgClr);
            elemById( "trcCn").appendChild( html);
         //   document.getElementById("countries").addEventListener("mouseleave", function(){
         //       util.removeClass( currentPage, "pageactive");
         //   });
			xmlCountries = null;
        }
        if( xmlSubShows) {
            addPage( "btnSs", "subshows", "trcSis");
            bgClr = getTreeBackgroundColor( fxStyle.subShow);
			
            html = elem.xmlToTree( xmlSubShows, "trSis", arSubShows, decrp, bgClr);
            elemById( "trcSis").appendChild( html);
            toggleTreeUnits( "trSis", config.units, arSubShows);
        //    document.getElementById("subshows").addEventListener("mouseleave", function(){
        //        util.removeClass( currentPage, "pageactive");
        //    });
			xmlSubShows = null;
        }
        if( xmlPavilions) {
            addPage( "btnPa", "pavilions", "trcP");
            bgClr = getTreeBackgroundColor( fxStyle.pavilion);
			
            html = elem.xmlToTree( xmlPavilions, "trP", arPavilions, decrp, bgClr);
            elemById( "trcP").appendChild( html);
            toggleTreeUnits( "trP", config.units, arPavilions);
           // document.getElementById("pavilions").addEventListener("mouseleave", function(){
          //      util.removeClass( currentPage, "pageactive");
          //  });
			xmlPavilions = null;
        }
    }
    
    function updateListUnits() {
        if( elemById( "btnPa") !== null) {
            toggleTreeUnits( "trP", config.units, arPavilions);
        }
        if( elemById( "btnSs") !== null) {
            toggleTreeUnits( "trSis", config.units, arSubShows);
        }
    }
    
    function toggleTreeUnits( treeName, units, arr) {
		var tree = elemById( treeName);
		var nodes = tree.getElementsByClassName( "comp");
		var i = 0;
		var len = nodes.length;
        var listData = null;
        var bth = null;
        var str = "";
		
		for( i = 0; i < len; i++) {
			listData = arr[ nodes[i].getAttribute( "data-index")];
			bth = data.booths[ listData.split( ",")[0]];
			if( bth.status === "0" || (config.rentMode && bth.status === "2")) {
				str = dataMgr.getBoothLabel( bth);
				nodes[i].getElementsByTagName( "span")[0].textContent = str;
			}
		}
    }
    
	function addAvailableBoothPage() {
        var newDiv = null;
		var bgColor = getTreeBackgroundColor( fxStyle.availableBooth);
		var textColor = fxStyle.availableBooth.clrText || fxStyle.mainHeader.clrText;
		
        if( config.showLists) {
            elemById( "boothListHeader").style.backgroundColor = bgColor;
            elemById( "boothListHeader").style.color = textColor;
			elemById( "boothTreeHeader").style.backgroundColor = bgColor;
            elemById( "boothTreeHeader").style.color = textColor;
			
			elemById( "btnReturnList").style.backgroundColor = textColor;
            elemById( "btnReturnList").style.color = bgColor;
			
			if( !data.smallLayout) {
				elemById( "btnAv").appendChild( elemById( "booths"));
			}
			
			boothList.getListElements();
			
			elemById( "boothFilter").appendChild( 
				elem.filterItem( "available", "Available " + txt.BOOTH, false));
			
			elemById( "boothFilter").appendChild( elem.filterItem( "tag", txt.EXHIBITOR_FILTER_TAGGED, false));
				// currently only local booths are in list
//			if( config.hasMultipleViews) {
//				elemById( "boothFilter").appendChild( 
//					elem.filterItem( "hall", txt.EXHIBITOR_FILTER_HALL, false));
//			}
			elemById( "boothFilter").appendChild( 
				elem.filterItem( "all", "All "+ txt.BOOTH + "s", false));
			elemById( "boothFilter").appendChild( 
				elem.filterItem( "bySize", "Available by Size", false));
			
			elemById( "boothTree").style.display = "none";
			
			newDiv = elem.newTreePage( "availBooths", "trcA");
			newDiv.className = "";
			elemById( "treeContainer").appendChild( newDiv);
        }
	}
    
	function initLegend() {
		if( config.bLegend) {
			fpLegend = new Legend( data, config);
		}
		
		if( fpLegend !== null) {
			elemById("floorplan").appendChild( fpLegend);
            // legend top
            fpLegend.style.top = elemById("control1").offsetTop + 48 + "px";
			
			elemById( "btnLegend").addEventListener( "click", function(){
				if( legendOpen) {
                    fpLegend.style.opacity = 0;
					legendOpen = false;
                    setTimeout( removeLegend, 300);
				}
				else {
                    fpLegend.style.display = "block";
                    fpLegend.style.opacity = 1;
					legendOpen = true;
				}
                util.toggleClass( elemById( "btnLegend"), "icon-check");
			});
			
            if( data.smallLayout || !config.legendOpen) {
                fpLegend .style.display = "none";
                legendOpen = false;
            }
		}
		else {
            if( elemById( "btnLegend")) {
                elemById( "btnLegend").style.display = "none";
            }
		}  
	}
    
    function removeLegend() {
        fpLegend.style.display = "none";
    }
	
    function resize() {
        if( currentPage && currentPage.getAttribute("id") !== "floorplan") {
            currentPage.style.height = data.pageHeight;
            elemById('trA').style.height = availHeightSubject(data.pageHeight);
            
        }
        if( banner) {
            banner.resize();
        }
		boothList.resize();
    }

    function loadSalesFp(value){
        document.removeEventListener( "Sales_Floorplan_Loaded", null)
        sales.setFloorplan( value);
    }
    
    return {
        addAvailableBoothPage: addAvailableBoothPage,
        disableSales: disableSales,
        isSalesLoggedIn: function() {
            return ( sales && sales.getLoggedIn());
        },
        initialize : init,
		initLegend: initLegend,
        handleAdBanner: handleAdBanner,
        initPeriodicFunctions: initPeriodicFunctions,
        loginRequired: loginRequired,
        fx5Login: fx5Login,
        resize: resize,
        setFloorPlan: function( value) {
            fp = value;
            if( sales !== null) {
                doc.dispatchEvent( new FxEvent( "Sales_Floorplan_Loaded", loadSalesFp(value)));
            }
        }
    };
};